import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap'
import { CreateModalTrigger } from '../components/CreateModalTrigger';
import { CustomerFields } from '../components/CustomerFields';
import { AggregatorConfigFields } from '../components/AggregatorConfigFields';
import { PolarisConfigFields } from '../components/PolarisConfigFields';
import { inject, observer } from 'mobx-react';
import { required, isNumeric, isSingleChar } from '../utils/ValidatorRulesUtils';
import { FormControl } from 'react-bootstrap';

@inject('configurationStore', 'organizationStore')
@observer
class Customer extends Component {
  displayName = Customer.name;

  state = {
    channelFilter: 0
  }
  componentDidMount() {
    const currentCustomerId = parseInt(this.props.match.params.customerId, 10);
    this.props.configurationStore.setCurrentCustomerId(currentCustomerId);
    this.props.configurationStore.getNotificationChannels();
    this.props.configurationStore.getNotificationTypes();
  }

  configRules = {
    friendlyName: [required],
    description: [required],
    adqRefId: [required, isNumeric],
    separator: [required, isSingleChar],
    channelId: [required]
  };

  setChannelFilter = (event) => {
    this.setState({ channelFilter: parseInt(event.target.value) })
  }
  
  render() {
    const { configurationStore, organizationStore } = this.props;
    if (configurationStore.isLoading || configurationStore.customer.configs === void 0)
      return <p><em>Loading...</em></p>;
    

    const { 
      customer, 
      updateCustomer, 
      createConfig, 
      notificationChannels, 
      notificationTypes,
      createPolarisConfig,
      customerHasPolarisConfig, 
      currentPolarisConfig 
    } = configurationStore;
    const hasConfigs = customer.configs.length > 0;
    
    let customerConfigsFiltered = customer.configs.sort((a, b) => (a.friendlyName > b.friendlyName) ? 1 : -1)
    if (this.state.channelFilter) {
      customerConfigsFiltered = customerConfigsFiltered.filter(config => config.channelId === this.state.channelFilter)
    }
    
    return (
      <div>
        <h1>{customer.name}</h1>
        <Link to={'/customer/'} className="mr-5">
            <Glyphicon glyph="arrow-left" /> All Customers
        </Link>
        {
          customerHasPolarisConfig ?
            <Link to={`/customer/${customer.id}/polaris/`} className="mr-5">
                Edit Polaris Config
            </Link> :
            <CreateModalTrigger triggerText='Add Polaris' title='Create Polaris config' render={({toggle}) =>
              <PolarisConfigFields buttonText='Create config' onSubmit={createPolarisConfig} closeModal={toggle} configurationStore={configurationStore} />
            }/> 
        }
        <Link to={`/customer/${customer.id}/branches/`} className="mr-5">
            Manage Branches
        </Link>
        <Link to={`/customer/${customer.id}/communication-preferences/`} className="mr-5">
            Manage Communication Preferences
        </Link>
        <hr></hr>
        <CustomerFields buttonText='Update' onSubmit={updateCustomer} initialState={customer} 
          customerUpdated={configurationStore.customerUpdated} configurationStore={configurationStore} organizationStore={organizationStore} />
        <br></br>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
          <CreateModalTrigger triggerText='Create config' title='Create new config' render={({toggle}) =>
              <AggregatorConfigFields buttonText='Create config' rules={this.configRules} onSubmit={createConfig} notificationChannels={notificationChannels} notificationTypes={notificationTypes} configurationStore={configurationStore} closeModal={toggle} />
            }
          />
          &nbsp;
          <CreateModalTrigger disabled={!hasConfigs} triggerText='Create from existing config' title='Create from existing config' render={({toggle}) =>
              <AggregatorConfigFields buttonText='Create config' isCopyFromExisting rules={this.configRules} onSubmit={createConfig} notificationChannels={notificationChannels} notificationTypes={notificationTypes} configurationStore={configurationStore} closeModal={toggle} />
            }
          />
          <div style={{ width: 200, marginLeft: 5 }}>
            <FormControl componentClass="select" value={this.state.channelFilter} onChange={this.setChannelFilter}>
                <option value="0">Filter Channel</option>
                <option value="1">Email</option>
                <option value="2">SMS</option>
                <option value="3">Voice</option>
            </FormControl>  
          </div>
        </div>
        <div className='list'>
          {
            customerConfigsFiltered.filter(config => !config.hidden).map(item => {
              return (
                <h4 className='item' key={item.id}>
                  <Link to={{ pathname: `/customer/${customer.id}/config/${item.id}`, state: this.state }}>
                    <Glyphicon glyph='pencil'></Glyphicon> {item.friendlyName}
                  </Link>
                </h4>
              );
            })
          }
         </div>
      </div>
    );
  }
}

export { Customer };